
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App.tsx';
import { ThemeProvider } from './app/design/ThemeProvider.tsx';
import { PlayerProvider } from './app/player/PlayerProvider.tsx';
import { ErrorBoundary } from './app/ErrorBoundary.tsx';
import './styles/index.css';

// Build marker to force new hashed bundle and help invalidate cached assets.
const STORIBLE_BUILD_TAG = 'deploy-2026-01-02-1';
if (typeof window !== 'undefined') {
  (window as any).__STORIBLE_BUILD__ = STORIBLE_BUILD_TAG;
  // eslint-disable-next-line no-console
  console.info('Storible build:', STORIBLE_BUILD_TAG);
}

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ErrorBoundary>
      <ThemeProvider>
        <PlayerProvider>
          <App />
        </PlayerProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </BrowserRouter>,
);
  
